module.exports = __webpack_public_path__ + "img/mobile-spectrum-UnderstandingData.945fcc1b.png";